<template>
  <v-card style='background: #F8F5FD; border: none' class="d-flex flex-column" :width="$isTablet ? (windowInnerWidth * 0.6) : (windowInnerWidth * 0.95 - 20)">
    <div class="d-flex flex-column align-center justify-center">
      <img style="width: 50px;" :src="require(`@/assets/images/icon-inprocess.png`)" class="mt-n4">
      <span
        style='color: #A75CFF; font-size: 22px; font-weight: 700'>{{ language === 'chinese' ? '等待审批' : 'Pending approval'
        }}
      </span>
    </div>
    <v-card-text class="d-flex flex-column align-start px-4 py-2">
      <div v-if="language === 'chinese'" class="prompt mb-2">
        您申请预定的{{ item.cityName }}{{ item.cityName === '大连' ? '' : item.buildName
        }}{{ item.roomName === 'King Landing' ? 'King\'s Landing' : item.roomName }}，信息如下：
      </div>
      <div v-else class="prompt mb-2">
        You have successfully made a reservation
        {{ item.cityValue }}{{ item.cityName === '大连' ? '' : item.buildingValue
        }}{{ item.roomName === 'King Landing' ? 'King\'s Landing' : item.roomName
        }}, The information is as follows:
      </div>
      <div class="w-full pr-4 rounded-lg d-flex flex-column" style="background: #FFFFFF">
        <div class="pa-4 d-flex">
          <v-avatar color="primary" size="70">
            <v-img
              :src="item.roomImgUrl ? item.roomImgUrl : 'https://myops.accenture.cn/fs_prod/files/MYOPS/20250509/286fe1495c2824f05dad402b6bc58067.png'">
            </v-img>
          </v-avatar>
          <div class="ml-4">
            <div style='width: 100%' class='d-flex align-center justify-space-between'>
              <div class='d-inline-block text-truncate' style='width: 70%'>
                  <span style='font-size: 18px; color: #000; font-weight: 700'>
                    {{ item.roomName }}
                  </span>
              </div>
            </div>
            <div
              v-if='item.capacity > 1'
              class='text-center mt-2 mr-2'
              style='width: 65px; height: 24px;border-radius: 12px;background: #F8F5FD'>
              <v-icon size='18' color='#803ED3' class='mr-1'>{{ icons.mdiAccountMultipleOutline
                }}
              </v-icon>
              <span style='font-size: 12px; color: #803ED3'>{{ item.capacity }}</span>
            </div>
            <div v-if="item.standard_services"
                 class='pl-2 image-grid position-absolute' style="bottom: 0">
              <div v-for="(service, index) in splitStandardServices(item.standard_services)"
                   :key="'StandardService-' + index">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-bind="attrs"
                      v-on="on"
                      v-if="getStandardServiceByName(service)"
                      class='mb-1 cursor-pointer' width='20'
                      :src="require(`@/assets/images/standard_services/${getStandardServiceByName(service).iconName}`)">
                    </v-img>
                  </template>
                  <span>{{ getStandardServiceByName(service).name }}</span>
                </v-tooltip>
              </div>
            </div>
            <div class='mt-1' style='margin-left: -3px'>
              <v-icon size='18' color='#A6A7A9'>{{ icons.mdiMapMarkerRadiusOutline }}</v-icon>
              <span style='color: #A6A7A9; font-size: 14px; font-weight: 400'>
                  {{ item.workplaceLocationValue }}
            </span>
            </div>
          </div>
        </div>
        <v-divider></v-divider>
        <div class="d-flex pa-4">
          <img style="width: 9px;" class="py-1" :src="require(`@/assets/images/icon-time.png`)">
          <div class="ml-2 d-flex flex-column justify-space-between">
            <div>{{ language === 'chinese' ? '开始时间' : 'Start' }}：
              <v-chip small class="mr-2">{{ getDateFromDate(item.start) }}</v-chip>
              <v-chip small>({{ calculateWeekday(item.start) }})</v-chip>
            </div>
            <div>{{ language === 'chinese' ? '结束时间' : 'End' }}：
              <v-chip small class="mr-2">{{ getDateFromDate(item.end) }}</v-chip>
              <v-chip small>({{ calculateWeekday(item.end) }})</v-chip>
            </div>
          </div>
        </div>
        <div :class="['d-flex', 'align-center', 'justify-center', 'mb-4']">
          <v-btn color='#A75CFF'
                 class="rounded-pill"
                 :loading='item.loading'
                 :disabled='item.disabled'
                 @click='cancelBooked(item)'
                 small
          >
            <span
              :style="{color: item.disabled ?'#5e5669ad' : '#ffffff'}">{{ language === 'chinese' ? '取消预订' : 'Cancellation'
              }}</span>
          </v-btn>
        </div>
      </div>
      <div>

      </div>
    </v-card-text>
    <div class='pa-4 pt-0' style='font-size: 13px'>
      <div>Your conference room/open workspace reservation request has been successfully submitted. We will confirm this
        reservation with you via email as soon as possible.
      </div>
      <div>
        During this period, if you have any questions or need further assistance, please contact <a
        href='mailto:GreaterChina.OfficeSupport@accenture.com'>GreaterChina.OfficeSupport@accenture.com</a>,
        Thank you.
      </div>
      <div>
        <span style="color:#B37102">Tips:</span> <span style="color: #B293C1">Check in for open/closed workspace should be no later than <span
        style="color: #7B508F" class="font-weight-bold">30 minutes</span> from the start of the reservation, and for conference rooms, it should be no later than <span
        style="color: #7B508F" class="font-weight-bold">15 minutes</span> from the start of the reservation. Please make sure to check in promptly to ensure that the reservation is not automatically cancelled.</span>
      </div>
    </div>
    <div class='pa-4 pt-0' style='font-size: 14px'>
      <div>您的会议室 / 工位预订申请已成功提交。我们会尽快通过邮件的形式向您确认此次预定。</div>
      <div>
        在此期间，若您有任何疑问或需要进一步的协助，请联系<a
        href='mailto:GreaterChina.OfficeSupport@accenture.com'>GreaterChina.OfficeSupport@accenture.com</a>,
        谢谢。
      </div>
      <div>
        <span style="color:#B37102">温馨提示:</span>
        <span style="color: #B293C1">开放/封闭工作空间的check-in不迟于预约开始时间的<span style="color: #7B508F" class="font-weight-bold">30分钟</span>
          ，会议室的check-in不迟于预约开始时间的<span style="color:#7B508F" class="font-weight-bold">15分钟</span>，请务必及时check-in以确保预约不会自动取消。</span>
      </div>
    </div>
  </v-card>
</template>
<script>
import { mdiAccountMultipleOutline, mdiMapMarkerRadiusOutline } from '@mdi/js'
import { cancelPlacesReservableInfo } from '@/modules/chat/api'
import moment from 'moment'
import { getChineseWeekday } from '@/modules/chat/util/ChatBotUtil'
import { StandardServicesMix } from '@/modules/chat/view/chatbot/mixin/commonMixin'

export default {
  props: {
    item: {
      roomName: '30F-2M001',
      buildindValue: 'Shanghai zhonghuan',
      capacity: 8,
    },
    language: {
      type: String,
      default: 'chinese',
    },
  },
  mixins: [StandardServicesMix],
  watch: {
    'item.msgId': {
      handler(val) {
        this.item.disabled = this.item.componentDisabled
      },
      immediate: true,
    },
  },
  computed: {
    windowInnerWidth() {
      return window.innerWidth
    },
  },
  data() {
    return {
      icons: {
        mdiMapMarkerRadiusOutline,
        mdiAccountMultipleOutline,
      },
    }
  },
  methods: {
    getDateFromDate(dateString) {
      return moment(dateString).format('YYYY-MM-DD HH:mm')
    },
    calculateWeekday(inputDate) {
      if (moment(inputDate, 'YYYY-MM-DD').isValid()) {
        const weekDay = moment(inputDate, 'YYYY-MM-DD').format('dddd')
        return this.language === 'chinese' ? getChineseWeekday(weekDay) : weekDay
      } else {
        return null
      }
    },
    async cancelBooked(item) {
      this.$set(item, 'loading', true)
      const { data: { code, data, msg } } = await cancelPlacesReservableInfo({
        number: item.bookedPlaceResult.number,
        roomName: item.roomName,
        roomId: item.roomId,
      })
      this.$set(item, 'loading', false)
      if (code === 200) {
        this.$set(item, 'disabled', true)
        this.$emit('cancelBookingCompletedEmit', { code, ...data })
      } else {
        this.$emit('cancelBookingCompletedEmit', { code, errorMsg: msg, ...data })
      }
    },
  },
}
</script>
<style scoped>
/* 图片纵向排列，超过三个图新起一列 */
.image-grid {
  margin-top: 10px;
  margin-left: -5px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20px, 1fr));
  grid-template-rows: repeat(3, 1fr);
  grid-auto-flow: column;
}

/* 移动端样式 */
@media (max-width: 767px) {
  .prompt {
    font-size: 14px;
    color: #333333
  }

  .place-detail {
    font-size: 13px;
  }

  .circle {
    margin-right: 4px;
    width: 12px;
    height: 12px;
    background: #a100ff;
    border-radius: 50%; /* 关键属性 */
  }
}

/* 桌面端样式 */
@media (min-width: 768px) {
  .prompt {
    font-size: 16px;
    color: #000000
  }

  .place-detail {
    font-size: 15px;
  }

  .circle {
    margin-right: 8px;
    width: 12px;
    height: 12px;
    background: #a100ff;
    border-radius: 50%; /* 关键属性 */
  }
}
</style>
